import React from 'react';
import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';

interface Props {
  text: string;
  selected: boolean;
  key: any;
}

const MobileMenuItem = ({ text, selected }: Props) => (
  <StyledMenuBtn className="menu-item" selected={selected}>
    {text}
  </StyledMenuBtn>
);

export default MobileMenuItem;

const StyledMenuBtn = styled.button<{ selected: boolean }>`
  margin: 0.5rem 1.2rem;
  color: ${p => p.theme.gray700};

  ${p =>
    p.selected &&
    css`
      border-bottom-width: 2px;
      border-color: #3d4852;
      color: ${p => p.theme.black};
    `};
`;
